export const homeKareStatus = [
  {
    label: 'Open',
    value: 'open',
  },
  {
    label: 'Inprogress',
    value: 'inprogress',
  },
  {
    label: 'Not Answered',
    value: 'notAnswered',
  },
  {
    label: 'Completed',
    value: 'completed',
  },
]

export const KEY_TYPE_ENTER = 'Enter'
